// src/properties/adminMediaPipelineApi.ts
import { apiClient } from "@maat/api-base";
var adminMediaPipelineApi = {
  getSummary: async (window) => {
    return apiClient.get("/main/api/admin/media-pipeline/summary", {
      params: window ? { window } : void 0
    });
  },
  listFailures: async (params) => {
    return apiClient.get("/main/api/admin/media-pipeline/failures", { params });
  }
};

export {
  adminMediaPipelineApi
};
